<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <back-button />
            <v-toolbar-title v-html="title" />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details
            />
          </v-toolbar>
        </template>
        <template v-slot:item.status="{ item }">
          {{ showLicenceStatus(item) }}
        </template>
        <template v-slot:item.device_id="{ item }">
          <span v-if="item.device_id">
            Asignada
          </span>
          <span v-else>
            No Asignada
          </span>
        </template>
        <template v-slot:item.enterprise_id="{ item }">
          <span v-if="item.enterprise_id">
            Asignada
          </span>
          <span v-else>
            No Asignada
          </span>
        </template>
        <template v-slot:item.dealer_id="{ item }">
          <span v-if="item.dealer_id">
            Asignada
          </span>
          <span v-else>
            No Asignada
          </span>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label><br>
          <v-btn
            color="blue darken-1"
            dark
            @click="reset"
          >
            Limpiar búsqueda
          </v-btn>
        </template>
      </v-data-table>
      <delete-dialog
        ref="delete"
        :message="message"
        :api-u-r-l="apiURL"
      />
    </v-col>
  </v-row>
</template>

<script>
import * as _ from 'underscore';
import BackButton from '~/components/BackButton';
import DeleteDialog from '~/components/Delete';

export default {
  middleware: 'auth',
  components: {
    // VuetifyTable,
    DeleteDialog,
    BackButton,
  },
  props: {
    dealerId: { default: '' },
    id_licencia: { default: '' },
    action: { default: '' },
  },
  data: () => ({
    loading: false,
    editedIndex: -1,
    options: {},
    search: '',
    items: [],
    name: '',
    totalItems: 0,
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    toggleStatus: false,
    message: '',
    headers: [
      {
        text: 'Código',
        value: 'code',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Empresa',
        value: 'enterprise_id',
        sortable: false,
      },
      {
        text: 'Distribuidor',
        value: 'dealer_id',
        sortable: false,
      },
      {
        text: 'Estatus',
        value: 'status',
        sortable: false,
      },
    ],
  }),
  computed: {
    apiURL() {
      return `/api/catalogs/dealers/${this.dealerId}/licences/${this.id_licencia}`;
    },
    title() {
      return `Códigos de Licencia de <b>${this.name}</b>`;
    },
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.options.page = 1;
        this.refreshTable();
      },
      deep: true,
    },
    apiURL: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
  mounted() {
    window.axios.get(`/api/catalogs/services/${this.id_licencia}`)
    .then((result) => {
      this.name = result.data.name;
    });
  },
  methods: {
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    showLicenceStatus(item) {
      let message = 'Asignable a: ';
      if (item.device_id === null) { message += 'Dispositivo, '; }
      if (item.dealer_id === null && item.enterprise_id === null) { message += 'Distribuidor, '; }
      if (item.enterprise_id === null) { message += 'Empresa.'; }
      return message;
    },
    refreshTable() {
      this.getDataFromApi()
      .then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise(async (resolve) => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage,
        } = this.options;
        const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
            const data = response.data.items;
            const { total } = response.data;
            return ({ data, total } || []);
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
      &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    openModalDelete(item) {
      this.$refs.delete.openModal(item);
    },
    reset() {
      this.search = '';
    },
  },
};
</script>
